module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACtSURBVEhL7ZLBDcIwDEVz6wAglREQkyCYp/OVDThzRuzBd9pftVLqOnF6gid9OT74/UvCnxzacdbgNM6JBnkj97j56JDH8FxyQbwlIn8ih7gl8JRsyklJiVlOckqy5cRSQvkxbgryi16ISOdoJWvyG9IPzyUiEZmlRJOnHBOWkmI50Uo+iEtO1g7OiFtOLIfFcqIJ3HKSElWTk7mwupyIWH7RLnJyRXaT/yQhfAH4YDR4GbjQKgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons8-double-down-24.png
// module id = 1182
// module chunks = 0